import React from "react"
import Helmet from "react-helmet"
import L10n from "lib/carrot-l10n"
import TitleMap from "utils/TitleMap"
import { useLocation } from "react-router"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Title = (props) => {
  const location = useLocation()
  const title = props.title ? props.title : TitleMap(location.pathname)

  return (
    <Helmet>
      <title>{`${title ? `${title} | ` : ""}${l`client.header.productTitle`}`}</title>
    </Helmet>
  )
}
export default Title
